import { render } from "./StaffReg.vue?vue&type=template&id=73f32269&scoped=true"
import script from "./StaffReg.vue?vue&type=script&lang=js"
export * from "./StaffReg.vue?vue&type=script&lang=js"

import "./StaffReg.vue?vue&type=style&index=0&id=73f32269&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73f32269"]])

export default __exports__